





































import mixins from 'vue-typed-mixins'
import VideoPlayIcon from '@/components/VideoPlayIcon.vue'
import MessageMixin from '@/mixins/MessageMixin'
import infiniteLoading from 'vue-infinite-loading'
import { mapMutations, mapGetters, mapActions } from 'vuex'
import * as _ from 'lodash'

export default mixins(MessageMixin).extend({
  name: 'MessageFileGallery',
  components: {
    infiniteLoading,
    'video-play-icon': VideoPlayIcon
  },
  data() {
    return {
      fetchPayload: {
        url: '/message/',
        params: {
          page: 'get_gallery',
          other_id: this.$route.params.id
        }
      }
    }
  },
  computed: {
    ...mapGetters('Chat', ['saveImgPoint', 'saveVideoPoint']),
    ...mapGetters('MessageFileGallery', ['enabledInfinite', 'entries', 'distance'])
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('MessageFileGallery', ['getEntries', 'infinite']),

    ...mapMutations('Chat', ['setImagePurchasePoint', 'setVideoPurchasePoint']),
    ...mapMutations('MessageFileGallery', ['setEntry']),

    /**
     * 無限スクロール
     */
    onInfinite($state) {
      const keys = Object.keys(this.entries)
      this.fetchPayload.params['newest_timestamp'] = keys[keys.length - 1]
      this.infinite({
        fetchPayload: this.fetchPayload,
        $state: $state
      })
    },

    /**
     * getEntries では無視される entries 以外のデータを処理
     */
    async fetchData(this: any) {
      const data = await this.getEntries(this.fetchPayload)
      if (data) {
        this.setImagePurchasePoint(data.image_purchase_point)
        this.setVideoPurchasePoint(data.video_purchase_point)
      }
    },

    /**
     * メディアをクリック
     */
    async handleMediaClick(timestamp: string, id: string, point: string) {
      const entry = this.entries[timestamp]
      const payload = await this.$_handleMediaClick(entry, timestamp, id, point)

      if (payload) {
        // データの更新があったなら lodash merge でオブジェクトをマージ
        // Object.assign() やスプレッド演算子では入れ子のオブジェクトをマージできない
        const newEntry = _.merge(entry, payload.entries)

        this.$set(this.entries, timestamp, newEntry)
        this.setEntry({
          index: timestamp,
          entry: newEntry
        })
      }
    }
  }
})
